import { Injectable } from '@angular/core';
import { Router } from '@angular/router';



// Import custom services
import { UserAuthenticationService } from '../firestore/user-authentication.service';
import { LanguageService } from '../language/language.service';



@Injectable({
  providedIn: 'root'
})
export class ControllerService {


  // This variable is only used to display some widgets that are not relevant from the security point of view
  public userIsLogged:boolean = false



  constructor(
    public userAuthenticationService:UserAuthenticationService,
    public languageService:LanguageService,
    private router: Router
  ){}



  // Initialization method
  initializeApp(){
    // Set the default language
    this.languageService.setLanguageAccordingToNavigatorLanguage()
    // Subscribe to the user login state
    this.subscribeToUserLoginState()
  }





  // ------ Navigation actions ----//

  // Method for subscribing to the user authentication service and checking if the user is logged in or not
  // Navigate to the login or landing page accordingly  
  async subscribeToUserLoginState(){
    await this.userAuthenticationService.getUserIsLoggedValue().subscribe(async (userIsLogged:boolean) => {
      if(userIsLogged){
        // Go to landing page
        this.router.navigate(['/']);
        // Store the variable value
        this.userIsLogged = true
      }else{
        //this.setCurrentAction('landingPage')
        this.router.navigate(['/login']);
        // Store the variable value
        this.userIsLogged = false
      }
    });
  }






  


  navigate(route:string){
    this.router.navigate([route])
  }








  
















  /*
  private loadScript(): void {
    // Verificar si el script ya existe
    if (!document.getElementById('jiraWidget')) {
      const script = document.createElement('script');
      script.src = 'https://jsd-widget.atlassian.com/assets/embed.js';
      script.id = 'jiraWidget';
      script.async = true;
      script.dataset['jsdEmbedded'] = '';
      script.dataset['key'] = 'a03271b7-096b-45aa-97c3-f0409b9d40b0'; // Usar tu clave real aquí
      script.dataset['baseUrl'] = 'https://jsd-widget.atlassian.com';
      document.body.appendChild(script);

      script.addEventListener('load', () => {
        // Script cargado, podrías inicializar aquí el widget o realizar acciones adicionales
        console.log('Script cargado')
      });
    }
  }

  private removeScript(): void {
    const script = document.getElementById('jiraWidget');
    if (script) {
      document.body.removeChild(script);
    }
  }
  */





            



}
